<template>
<div>
  <div class="header-spacer">
    <h3 class="page-header">Menu</h3>
    <h5 class="pdf-button" @click="pdfVisible = !pdfVisible"><span v-if="!pdfVisible">Reveal PDF Version</span><span v-else>Hide PDF Version</span></h5>
  </div>
  <div class="rr-alert">
  </div>
  <div v-show="!pdfVisible">
    <!-- <template v-if='specials && specials.length != 0'>
      <h5 class="wine-type">Specials</h5>
      <div class="row specials">
        <div v-for="(item, index) in specials" :key="index" class="col-12 col-md-4">
            <app-menu-item
              :key="item.name"
              :index="index"
              :name="item.name"
              :desc="item.desc"
              :price="item.price"
              :imageUrl="item.imageUrl"
              :marked="item.marked"></app-menu-item>
        </div>
      </div>
    </template> -->
    <div class="expander">
      <div
        :class="startersVisible ? null : 'collapsed'"
        :aria-expanded="startersVisible ? 'true' : 'false'"
        aria-controls="starters"
        @click="startersVisible = !startersVisible"
        class="expander-header">
        <h5>Starters</h5>
        <div v-if="!startersVisible" class="expander-status">
          <strong>&#43;</strong>
        </div>
        <div v-else class="expander-status">
          <strong>&#8722;</strong>
        </div>
      </div>
      <b-collapse id="starters" v-model="startersVisible">
        <div class="row">
          <div v-for="(col, index) in startersColumns" :key="index" class="col-12 col-md-4">
            <template v-for="(item, index) in col">
              <app-menu-item
                :key="item.name"
                :index="index"
                :name="item.name"
                :desc="item.desc"
                :price="item.price"
                :imageUrl="item.imageUrl"
                :marked="item.marked"></app-menu-item>
            </template>
          </div>
        </div>
      </b-collapse>
    </div>
    <div class="expander">
      <div
        :class="mainCourseVisible ? null : 'collapsed'"
        :aria-expanded="mainCourseVisible ? 'true' : 'false'"
        aria-controls="main-course"
        @click="mainCourseVisible = !mainCourseVisible"
        class="expander-header">
        <h5>Main Courses</h5>
        <div v-if="!mainCourseVisible" class="expander-status">
          <strong>&#43;</strong>
        </div>
        <div v-else class="expander-status">
          <strong>&#8722;</strong>
        </div>
      </div>
      <b-collapse id="main-course" v-model="mainCourseVisible">
        <div class="row">
          <div v-for="(col, index) in mainCoursesColumns" :key="index" class="col-12 col-md-4">
            <template v-for="(item, index) in col">
              <app-menu-item
                :key="item.name"
                :index="index"
                :name="item.name"
                :desc="item.desc"
                :price="item.price"
                :imageUrl="item.imageUrl"
                :marked="item.marked"></app-menu-item>
            </template>
          </div>
        </div>
      </b-collapse>
    </div>
    <div class="expander">
      <div
        :class="dessertsVisible ? null : 'collapsed'"
        :aria-expanded="dessertsVisible ? 'true' : 'false'"
        aria-controls="dessert"
        @click="dessertsVisible = !dessertsVisible"
        class="expander-header">
        <h5>Desserts</h5>
        <div v-if="!dessertsVisible" class="expander-status">
          <strong>&#43;</strong>
        </div>
        <div v-else class="expander-status">
          <strong>&#8722;</strong>
        </div>
      </div>
      <b-collapse id="dessert" v-model="dessertsVisible">
        <div class="row">
          <div v-for="(col, index) in dessertsColumns" :key="index" class="col-12 col-md-4">
            <template v-for="(item, index) in col">
              <app-menu-item
                :key="item.name"
                :index="index"
                :name="item.name"
                :desc="item.desc"
                :price="item.price"
                :imageUrl="item.imageUrl"></app-menu-item>
            </template>
          </div>
        </div>
      </b-collapse>
    </div>
    <!-- <div class="expander">
      <div
        :class="drinksVisible ? null : 'collapsed'"
        :aria-expanded="drinksVisible ? 'true' : 'false'"
        aria-controls="drinks"
        @click="drinksVisible = !drinksVisible"
        class="expander-header">
        <h5>Cocktails</h5>
        <p class="expander-subtitle">(Full bar available)</p>
        <div v-if="!drinksVisible" class="expander-status">
          <strong>&#43;</strong>
        </div>
        <div v-else class="expander-status">
          <strong>&#8722;</strong>
        </div>
      </div>
      <b-collapse id="drinks" v-model="drinksVisible">
        <div class="row">
          <div v-for="(col, index) in drinksColumns" :key="index" class="col-12 col-md-4">
            <template v-for="(item, index) in col">
              <app-menu-item
                :key="item.name"
                :index="index"
                :name="item.name"
                :desc="item.desc"
                :price="item.price"
                :imageUrl="item.imageUrl"></app-menu-item>
            </template>
          </div>
        </div>
      </b-collapse>
    </div> -->
    <div class="expander">
      <div
        :class="winesVisible ? null : 'collapsed'"
        :aria-expanded="winesVisible ? 'true' : 'false'"
        aria-controls="wines"
        @click="winesVisible = !winesVisible"
        class="expander-header">
        <h5>Wine List</h5>
        <div v-if="!winesVisible" class="expander-status">
          <strong>&#43;</strong>
        </div>
        <div v-else class="expander-status">
          <strong>&#8722;</strong>
        </div>
      </div>
      <b-collapse id="wines" v-model="winesVisible">
        <h5 class="wine-type">White</h5>
        <div class="row">
          <div v-for="(col, index) in wineListWhiteColumns" :key="index" class="col-12 col-md-4">
            <template v-for="(item, index) in col">
              <app-menu-item
                :key="item.name"
                :index="index"
                :name="item.name"
                :desc="item.desc"
                :price="item.price"
                :bottlePrice="item.bottlePrice"
                :type="item.type"
                :location="item.location"
                :imageUrl="item.imageUrl"></app-menu-item>
            </template>
          </div>
        </div>
        <h5 class="wine-type">Red</h5>
        <div class="row">
          <div v-for="(col, index) in wineListRedColumns" :key="index" class="col-12 col-md-4">
            <template v-for="(item, index) in col">
              <app-menu-item
                :key="item.name"
                :index="index"
                :name="item.name"
                :desc="item.desc"
                :price="item.price"
                :bottlePrice="item.bottlePrice"
                :type="item.type"
                :location="item.location"
                :imageUrl="item.imageUrl"></app-menu-item>
            </template>
          </div>
        </div>
        <h5 class="wine-type">Sparkling</h5>
        <div class="row">
          <div v-for="(col, index) in wineListSparklingColumns" :key="index" class="col-12 col-md-4">
            <template v-for="(item, index) in col">
              <app-menu-item
                :key="item.name"
                :index="index"
                :name="item.name"
                :desc="item.desc"
                :price="item.price"
                :bottlePrice="item.bottlePrice"
                :type="item.type"
                :location="item.location"
                :imageUrl="item.imageUrl"></app-menu-item>
            </template>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
  <div v-show="pdfVisible">
    <div class="row">
      <div v-for="pdfMenu in dataPdfMenus" :key="pdfMenu.pdf" class="col-12 col-xl-6">
        <a :href="pdfMenu.pdf" target="_blank" rel=”noreferrer”><button class="pdf-download">Open PDF</button></a>
        <img class="menu-vector" :src="pdfMenu.svg" :alt="pdfMenu.alt" />
      </div>
    </div>
  </div>
  <div class="disclaimer">
    <div>
      <strong class="star">&#42;</strong>
      <p>This menu item can be cooked to you liking.</p>
    </div>
    <div>
      <strong class="star">&#42;</strong>
      <p>Consuming raw or undercooked meat, fish, shellfish or fresh shell eggs may increase your risk of food borne illness, especially if you have certain medical conditions.</p>
    </div>
    <p>Before placing your order, please inform your server if a person in your party has a food allergy.</p>
    <p>Menu Items and prices subject to change.</p>
    <p>All menu items come as described and are not subject to change.</p>
    <p>A 20% gratuity will be added to parties of 6 or more.</p>
    <p>Share charge on all Entrees - $5</p>
  </div>
</div>
</template>

<script>
import { dataSpecials,
  dataStarters,
  dataMainCourses,
  dataDesserts,
  dataDrinks,
  dataWineListWhite,
  dataWineListRed,
  dataWineListSparkling,
  dataPdfMenus } from '../data'
import MenuItem from './MenuItem'
export default {
  components: {
    'app-menu-item': MenuItem
  },
  name: 'Menu',
  metaInfo: {
    title: 'Red Rooster Bistro',
    titleTemplate: '%s | Menu',
    meta: [
      {
        name: 'description',
        content: 'View our menu - Quiet French-American bistro in the heart of the North Fork\'s wine country.'
      },
      {
        name: 'keywords',
        content: 'Red Rooster Menu'
      }
    ]
  },
  data: function () {
    // upload menu images in a 4:3 (width:height) ratio
    return {
      pdfVisible: false,
      dataPdfMenus: dataPdfMenus,

      startersVisible: false,
      mainCourseVisible: false,
      dessertsVisible: false,
      drinksVisible: false,
      winesVisible: false,

      specials: dataSpecials,
      startersColumns: [],
      mainCoursesColumns: [],
      dessertsColumns: [],
      drinksColumns: [],
      wineListWhiteColumns: [],
      wineListRedColumns: [],
      wineListSparklingColumns: []
    }
  },
  methods: {
    createMenuSection: function (menuList, colHeight) {
      let returnList
      if (Math.floor(colHeight) < Math.round(colHeight)) {
        // rounded up
        returnList = [menuList.splice(0, Math.ceil(colHeight)),
          menuList.splice(0, Math.ceil(colHeight)),
          menuList.splice(0, Math.floor(colHeight))]
      } else {
        // rounded down
        returnList = [menuList.splice(0, Math.ceil(colHeight)),
          menuList.splice(0, Math.floor(colHeight)),
          menuList.splice(0, Math.floor(colHeight))]
      }
      return returnList
    }
  },
  mounted: function () {
    let colHeight = dataStarters.length / 3
    this.startersColumns = this.createMenuSection(dataStarters, colHeight)

    colHeight = Math.ceil(dataMainCourses.length / 3)
    this.mainCoursesColumns = this.createMenuSection(dataMainCourses, colHeight)

    colHeight = Math.ceil(dataDesserts.length / 3)
    this.dessertsColumns = this.createMenuSection(dataDesserts, colHeight)

    colHeight = Math.ceil(dataDrinks.length / 3)
    this.drinksColumns = this.createMenuSection(dataDrinks, colHeight)

    colHeight = Math.ceil(dataWineListWhite.length / 3)
    this.wineListWhiteColumns = this.createMenuSection(dataWineListWhite, colHeight)

    colHeight = Math.ceil(dataWineListRed.length / 3)
    this.wineListRedColumns = this.createMenuSection(dataWineListRed, colHeight)

    colHeight = Math.ceil(dataWineListSparkling.length / 3)
    this.wineListSparklingColumns = this.createMenuSection(dataWineListSparkling, colHeight)
  }
}
</script>

<style scoped>
.disclaimer {
  font-size: 0.8em;
  text-align: center;
  margin-top: 40px
}

.disclaimer > div {
  display: flex;
  justify-content: center;
}

.menu-vector {
  width: 100%;
  margin-bottom: 20px;
  box-shadow: 0px 0px 3px #888888;
  object-fit:inherit;
}

.menu-space {
  height: 200px;
}

.page-header {
  margin-bottom: 40px;
}

.expander {
  margin-bottom: 20px;
}

.expander-header {
  background-color: white;
  height: 50px;
  box-shadow: 0px 0px 3px #888888;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.expander-header > h5 {
  margin: 0;
  margin-left: 30px;
}

.expander-subtitle {
  margin: 0;
  font-size: 0.9em;
  color: #8a0707;
}

.expander-status {
  margin-right: 30px;
  font-size: 2em;
  user-select: none;
}

.star {
  color: #8a0707;
  font-size: 1.6em;
  margin-right: 5px;
}

.wine-type {
  width: fit-content;
  margin-left: 30px;
  margin-top: 30px;
  margin-bottom: 0;
  font-size: 1.5em;
  font-weight: bold;
}

.header-spacer {
  display: flex;
  justify-content: space-between;
}

.pdf-button {
  height: 50px;
  line-height: 50px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: white;
  box-shadow: 0px 0px 3px #888888;
  border-radius: 10px;
  user-select: none;
  cursor: pointer;
}

.pdf-download {
  width: 100%;
  background-color: #8a0707;
  color: #f7f7f7;
  border: none;
  box-shadow: 0px 0px 3px #888888;
  line-height: 30px;
}

.specials {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue